import React from 'react'

const Background = ({ children }) => {
    return <div className='bg-gray-200 h-full lg:w-full dark:bg-gray-800'>{children}</div>
}

export default Background
